"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRootCategory = exports.removeRootCategory = void 0;
var rootFromUrl = new RegExp(/^.*?(\/)/);
var removeRootCategory = function removeRootCategory(url) {
  return global.__appConfig__.rootCategoryHideInUrl ? url.replace(rootFromUrl, "") : url;
};
exports.removeRootCategory = removeRootCategory;
var getRootCategory = function getRootCategory(url) {
  var _url$match;
  return global.__appConfig__.rootCategoryHideInUrl ? url === null || url === void 0 ? void 0 : (_url$match = url.match(rootFromUrl)) === null || _url$match === void 0 ? void 0 : _url$match[0] : "";
};
exports.getRootCategory = getRootCategory;